import React from "react";

function ContactsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1388_2167)">
        <path
          d="M6.7875 15.6C8.39062 13.5938 12.0469 8.73125 12.0469 6C12.0469 2.6875 9.35938 0 6.04688 0C2.73438 0 0.046875 2.6875 0.046875 6C0.046875 8.73125 3.70312 13.5938 5.30625 15.6C5.69063 16.0781 6.40312 16.0781 6.7875 15.6ZM6.04688 4C6.57731 4 7.08602 4.21071 7.46109 4.58579C7.83616 4.96086 8.04688 5.46957 8.04688 6C8.04688 6.53043 7.83616 7.03914 7.46109 7.41421C7.08602 7.78929 6.57731 8 6.04688 8C5.51644 8 5.00773 7.78929 4.63266 7.41421C4.25759 7.03914 4.04688 6.53043 4.04688 6C4.04688 5.46957 4.25759 4.96086 4.63266 4.58579C5.00773 4.21071 5.51644 4 6.04688 4Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1388_2167">
          <path d="M0.046875 0H12.0469V16H0.046875V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ContactsIcon;


